import { useEffect, useState } from "react";
import { getCachedImage, fallbackImage } from "../utils/getCachedImage";

export function useCachedImage(
  imageSource: string | undefined,
  username: string,
  userId: string | number,
) {
  const [cachedImage, setCachedImage] = useState<string>(fallbackImage);

  useEffect(() => {
    const imageUrlToUse =
      imageSource ||
      `https://api.dicebear.com/8.x/miniavs/svg?seed=${encodeURIComponent(username)}`;
    let isMounted = true;
    let initialLetter =
      username && username.length > 0 ? username.charAt(0) : "";
    if (!initialLetter) {
      initialLetter =
        userId && userId.toString().length > 0
          ? userId.toString().charAt(0)
          : "";
    }
    getCachedImage(imageUrlToUse, initialLetter).then((img) => {
      if (isMounted) setCachedImage(img);
    });
    return () => {
      isMounted = false;
    };
  }, [imageSource, username, userId]);

  return cachedImage;
}
